const pendingLoads = [];

export const registerPendingLoad = (promise) => {
  const settled = promise.catch(() => {});
  pendingLoads.push(settled);
  return promise;
};

export const waitForRegisteredLoads = () => Promise.all(pendingLoads);
